import React from 'react';

import { Alert, Stack, Typography } from '@mui/material';

import { severityToAlertColor } from './campaignScheduleViolationFormatter';
import type { GroupedViolation } from './campaignScheduleViolationFormatter';

interface Props {
  violation: GroupedViolation;
}

// See README.md#violation-display-rules.
export default function GroupedViolationAlert({ violation }: Props) {
  const lines = violation.text.split('\n').filter((line) => line.trim().length > 0);
  const hasHeading = lines.length > 1 && lines[0].endsWith(':');

  return (
    <Alert severity={severityToAlertColor(violation.severity)}>
      <Stack spacing={0.5}>
        {lines.map((line, index) => {
          const isHeadingLine = hasHeading && index === 0;
          const isTrailingCta = index > 0 && !line.startsWith('- ');

          return (
            <Typography
              key={index}
              component="div"
              fontWeight={isHeadingLine || isTrailingCta ? 700 : undefined}
              variant="body2"
            >
              {line}
            </Typography>
          );
        })}
      </Stack>
    </Alert>
  );
}
